var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('TodoList',{attrs:{"todos":_vm.todos,"sort-asc":!_vm.historyMode,"is-last-page":_vm.isLastPage,"is-loading":_vm.isLoading,"show-add-hint":false},on:{"loadMoreTodos":_vm.loadMoreTodos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }